module.exports = function (data) { //
    const globalContext = {
        pageInfo: {
            stateParams: data.pageInfo.stateParams,
            fullURL: data.pageInfo.fullUrl,  // todo
            referringURL: data.pageInfo.referringUrl,  // todo
            channel: 'Direct',
            // server: '',  // domain + abstract sub domain in url (ex: bws.woolworths)
            pageID: data.pageInfo.id,  // todo: add unique page id (maybe replace by state full name) ex : shop.search
            // breadCrumbs: '',  // todo: update this when there is a component state change without url change
            brand: 'BWS',
            previousPageName: data.pageInfo.previousPageName
            // primaryCatagory: '',  // todo: ex: Beer, Wine, Spirits
            // siteSubSection: '',  //
            // subCategory1: '',
            // subCategory2: '',
            // subCategory3: '',
            // campaignCode: ''
        },
        user: data.user
    };

    return globalContext;
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/analytics/atm-global-mapper.js
 **/